import { Close } from "@mui/icons-material";
import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import Styles from "./RaDateCHange.module.css";
import TextInput from "../../../commons/Inputs/TextInput/TextInput";
import DateInput from "../../../commons/Inputs/DateInput/DateInput";
import TimeInput from "../../../commons/Inputs/TimeInput/TimeInput";
import {
  alterTableRa,
  bucketFillAfter,
  bucketFillBefore,
} from "../../../Services/Admin/Alter";
import {
  formatDateElement,
  formatDateElementReverse,
} from "../../../commons/FormatDate";

const RaDateCHange = ({ open, handleClose }) => {
  const [tenderNo, setTenderNo] = useState("");
  const [formState, setFormState] = useState({
    tenderStartDate: null,
    tenderStartTime: null,
    tenderEndDate: null,
    tenderEndTime: null,
    biddingStartDate: null,
    biddingEndDate: null,
    biddingStartTime: null,
    biddingEndTime: null,
    auctionStartDate: null,
    auctionEndDate: null,
    auctionStartTime: null,
    auctionEndTime: null,
  });

  useEffect(() => {
    handleSubmit();
  }, [formState]);

  const handleState = (field, value) => {
    setFormState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleTenderNo = (value) => {
    let data = value?.split("_")?.[0]?.split("E")?.[1];
    console.debug(data);
    setTenderNo(data);
  };

  const handleSubmit = async () => {
    let payload = {};

    if (formState?.tenderStartDate) {
      payload.tenderStartDateTime = `${formatDateElementReverse(
        formState.tenderStartDate
      )} ${formState.tenderStartTime || "00:00"}`;
    }

    if (formState?.tenderEndDate) {
      payload.tenderCloseDateTime = `${formatDateElementReverse(
        formState.tenderEndDate
      )} ${formState.tenderEndTime || "00:00"}`;
    }

    if (formState?.biddingStartDate) {
      payload.bidStartDateTime = `${formatDateElementReverse(
        formState.biddingStartDate
      )} ${formState.biddingStartTime || "00:00"}`;
    }

    if (formState?.biddingEndDate) {
      const biddingEnd = `${formatDateElementReverse(
        formState.biddingEndDate
      )} ${formState.biddingEndTime || "00:00"}`;
      payload.bidCloseDateTime = biddingEnd;
      payload.ipoDateTime = biddingEnd;
    }

    if (formState?.auctionStartDate) {
      payload.auctionStartDateTime = `${formatDateElementReverse(
        formState.auctionStartDate
      )} ${formState.auctionStartTime || "00:00"}`;
    }

    if (formState?.auctionEndDate) {
      payload.auctionCloseDateTime = `${formatDateElementReverse(
        formState.auctionEndDate
      )} ${formState.auctionEndTime || "00:00"}`;
    }

    console.debug(payload, tenderNo);

    // Only proceed if payload is not empty
    if (Object.keys(payload).length > 0) {
      let res = await alterTableRa(payload, tenderNo);
      if (res?.data?.code === 200) {
        bucketFill();
      }
    } else {
      console.warn("No valid date fields found. Payload not sent.");
    }
  };

  const bucketFill = async () => {
    await bucketFillBefore();
    await bucketFillAfter();
    handleClose();
    window.location.reload();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.dateChangeModal}`}>
        <div className="modalHeading">
          <div className="headingText">Reverse Auction</div>
          <Close
            onClick={handleClose}
            style={{ cursor: "pointer", fontSize: "18px" }}
            alterButton={false}
          />
        </div>
        <div className={Styles.auctionContainer}>
          <TextInput
            heading={"Tender Number"}
            example={"TE107_OCT0825_OCT1825"}
            value={formState?.tenderNo}
            onChange={(value) => handleTenderNo(value)}
            type={"text"}
            height={40}
          />
        </div>
        <div className={Styles.buttonContainer}>
          <div
            className="activeButton"
            onClick={() => handleState("tenderStartDate", new Date())}
          >
            Start Tender
          </div>
          <div
            className="activeButton"
            onClick={() => handleState("tenderEndDate", new Date())}
          >
            End Tender
          </div>
          <div
            className="activeButton"
            onClick={() => handleState("biddingStartDate", new Date())}
          >
            Start Bidding
          </div>
          <div
            className="activeButton"
            onClick={() => handleState("biddingEndDate", new Date())}
          >
            End Bidding
          </div>
          <div
            className="activeButton"
            onClick={() => handleState("auctionStartDate", new Date())}
          >
            Start Auction
          </div>
          <div
            className="activeButton"
            onClick={() => handleState("auctionEndDate", new Date())}
          >
            End Auction
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RaDateCHange;
